/*
 * Authors: mariushirjanu, Koen, Triadi
 * Created: 30/10/2015
 * Upgraded: 20/03/2023
 */
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { OrderEntryWebshopService } from '../../webshop/order-entry-webshop.service';
import { GaWizardService } from '@app/shared/wizard/ga-wizard.service';
import { LocationDataType, OrderEntryLocationDataService } from '../order-entry-location-data.service';
import { BaseOrderEntryLocationComponent } from '../base-order-entry-location.component';
import { OrderEntryShippingService } from '../shipping/order-entry-shipping.service';
import { OrderEntryInvoiceService } from './order-entry-invoice.service';
import { OrderLocationEinvoiceComponent } from './order-location-einvoice.component';
import { OrderLocationAddressComponent } from '../address/order-location-address.component';
import { OrderLocationContactComponent } from '../order-location-contact.component';
import { GaDeferredService } from '@app/shared/services/ga-deferred.service';
import { GaValidateService } from '@app/shared/formly/ga-validate.service';
import { BillingType } from '../../order-entry-data.service';
import { OrderEntryRequesterService } from '@app/main/order/entry/requester/order-entry-requester.service';
import { OrderEntryService } from '@app/main/order/entry/order-entry.service';

@Component({
  selector: 'order-entry-invoice',
  template: `
    <div class="order-location">

      <h2 *ngIf="loading">
        <activity-indicator toLoad="ORDERENTRY.LOCATION.LOADING_TEXT"></activity-indicator>
      </h2>
      <div *ngIf="!loading">
        <order-location-billing-type
          [locationToModel]="locationToModel"
          [dataType]="dataType"
          (onBillingTypeChange)="onBillingTypeChange($event)"></order-location-billing-type>

        <order-location-address
          title="ORDERENTRY.INVOICE.ADDRESS.TITLE"
          [locationToModel]="locationToModel"
          [otherLocationToModel]="otherLocationToModel"
          [dataType]="dataType"
          [fixedList]="fixedList"
          [billingType]="billingType"
          (onLoadAddressDone)="onLoadAddressDone()"
          (onAddressTypeChange)="onAddressTypeChange($event)"
          (onLocationChange)="onLocationChange($event)"></order-location-address>

        <order-location-einvoice
          [locationToModel]="locationToModel"
          [fixedList]="fixedList"
          [billingType]="billingType"
          [addressType]="addressType"
          [location]="location"></order-location-einvoice>

        <order-location-contact
          title="ORDERENTRY.INVOICE.CONTACT.TITLE"
          [locationToModel]="locationToModel"
          [otherLocationToModel]="otherLocationToModel"
          [dataType]="dataType"
          [fixedList]="fixedList"
          [billingType]="billingType"
          [addressType]="addressType"
          [location]="location"
          (onLoadContactDone)="onLoadContactDone()"></order-location-contact>

        <order-location-comments
          title="ORDERENTRY.INVOICE.COMMENTS"
          [locationToModel]="locationToModel"
          [addressType]="addressType"
          [location]="location"></order-location-comments>
      </div>
    </div>
  `,
  styleUrls: [ '../order-entry-location.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class OrderEntryInvoiceComponent extends BaseOrderEntryLocationComponent {
  @ViewChild(OrderLocationAddressComponent) public orderLocationAddressComponent:OrderLocationAddressComponent;
  @ViewChild(OrderLocationEinvoiceComponent) public orderLocationEinvoiceComponent:OrderLocationEinvoiceComponent;
  @ViewChild(OrderLocationContactComponent) public orderLocationContactComponent:OrderLocationContactComponent;

  constructor(
    private validateService:GaValidateService,
    protected orderEntryWebshopService:OrderEntryWebshopService,
    protected orderEntryLocationDataService:OrderEntryLocationDataService,
    protected orderEntryShippingService:OrderEntryShippingService,
    protected orderEntryInvoiceService:OrderEntryInvoiceService,
    orderEntryRequesterService:OrderEntryRequesterService,
    orderEntryService:OrderEntryService,
    deferredService:GaDeferredService,
    wizardService:GaWizardService
  ) {
    super(orderEntryRequesterService, orderEntryWebshopService, orderEntryLocationDataService, orderEntryService, wizardService, deferredService);

    // set component models
    this.locationToModel = this.orderEntryInvoiceService;
    this.otherLocationToModel = this.orderEntryShippingService;
    this.dataType = LocationDataType.INVOICE;
  }

  public onBillingTypeChange = (billingType:BillingType):void => {
    this.billingType = billingType;
  };

  public beforeValidate = ():Promise<any> => {
    return Promise.all([this.onAddressInitDeferred.promise, this.onContactInitDeferred.promise])
      .then(() => Promise.all([
        this.orderEntryLocationDataService.isLoadingDone(),
        this.orderLocationAddressComponent.beforeValidate(),
        this.orderLocationEinvoiceComponent.beforeValidate(),
        this.orderLocationContactComponent.beforeValidate()
      ]));
  };

  public validate = ():Promise<void|string[]> => {
    return this.validateService.validateSubcomponents([
      this.orderLocationAddressComponent.validate(),
      this.orderLocationEinvoiceComponent.validate(),
      this.orderLocationContactComponent.validate()
    ]);
  };
}